import { router } from "src/js/router/react-router";
import { setSelectedProjectId } from "src/js/stores/site/actions/setSelectedProject";
import { ProjectEventName } from "react-migration/lib/util/logEventV2";
import { logEventV2 } from "react-migration/lib/util/logEventV2";
import ROUTES from "src/js/router/routes";

export const setSelectedProject = (projectId?: string, eventName?: ProjectEventName) => {
  if (projectId) {
    logEventV2({ name: eventName as ProjectEventName, properties: { projectId } });
    setSelectedProjectId(projectId);
    router.push({ name: ROUTES.SITES });
  }
};
